import { useState, useEffect } from "react";
import { downloadFile } from "../../api/uploadService";

export function useImgSrc(fileId) {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(false);
  const [imgLoading, setImgLoading] = useState(false);

  useEffect(() => {
    if (!fileId) return;
    setImgLoading(true);
    downloadFile(fileId)
      .then((blob) => {
        setSrc(URL.createObjectURL(blob));
        setImgLoading(false);
      })
      .catch((err) => {
        console.error("Image fetch failed:", err);
        setError(true);
        setImgLoading(false);
      });

    return () => {
      if (src) URL.revokeObjectURL(src);
    };
  }, [fileId]);

  return { imgLoading, src, error };
}